<template>
	<div class="container bg-white p-4">
		<div class="text-center mb-12" style="font-size: 1.75rem; font-weight:600">
			{{ ppcData.marketing_block_question }}
		</div>

		<div class="grid grid-cols-1 md:grid-cols-3 gap-6 mx-auto px-6">
			<div v-for="(block, index) in marketingBlocks" :key="index" class="container">

				<div class="image-container" :style="{ backgroundImage: `url('${urlLocation}${block.image}')` }">

					<div class="overlay-text">
						<h2 class="text-center px-2 py-2 font-semibold" style="color: #fff">
							{{ block.heading }}
						</h2>
						<p class="text-center px-3" style="color: #fff;font-size: 1rem;">
							{{ block.copy }}
						</p>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
const props = defineProps({
	ppcData: {
		type: Object,
		required: true,
	},
	urlLocation: {
		type: String,
		required: true,
	},
	currentPackage: {
		type: [Number, Object],
		default: null,
	},
});

const marketingBlocks = computed(() => {
	return [
		{
			image: props.ppcData.marketing_block_1_image,
			heading: props.ppcData.marketing_block_1_heading,
			copy: props.ppcData.marketing_block_1_copy,
			bottomOffset: 32,
			overlayHeight: 32,
		},
		{
			image: props.ppcData.marketing_block_2_image,
			heading: props.ppcData.marketing_block_2_heading,
			copy: props.ppcData.marketing_block_2_copy,
			bottomOffset: 32,
			overlayHeight: 32,
		},
		{
			image: props.ppcData.marketing_block_3_image,
			heading: props.ppcData.marketing_block_3_heading,
			copy: props.ppcData.marketing_block_3_copy,
			bottomOffset: 32,
			overlayHeight: 32,
		},
	];
});
</script>


<style scoped>
.image-container {
	position: relative;
	height: 450px;
	background-position: 50% 50%;
	background-size: cover;
	border-radius: 20px;
}

.overlay-text {
	background: #517185;
	opacity: 0.85;
	position: absolute;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
	transform: translate(0%, 0%);
	bottom: 0px;
	height: 215px;
}
</style>